<template>
  <div class="font-nunito min-h-screen bg-zinc-900 flex items-center justify-center p-1 sm:p-4 font-sans">
    <!-- Container principal -->
    <div class="w-full max-w-xl">
      <!-- Logo -->
      <div class="flex items-center justify-center mb-8">
        <img src="@/assets/bot_express_logo.png" alt="Logo" class="h-auto w-[180px] sm:w-[280px]">
      </div>

      <!-- Card de cadastro -->
      <div class="bg-white/5 rounded-xl overflow-hidden mb-8 sm:mb-0">
        <div class="p-6 sm:p-8">
          <!-- Cabeçalho -->
          <div class="mb-8">
            <h2 class="text-white text-2xl font-bold mb-2 tracking-tight">Criar sua conta</h2>
            <p class="text-zinc-300">Preencha os dados abaixo para começar</p>
          </div>

          <!-- Formulário -->
          <form @submit.prevent="handleRegister" class="space-y-5">
            <!-- Nome -->
            <div class="space-y-2">
              <label for="name" class="block text-sm font-medium text-zinc-200">Nome Completo ou Razão Social</label>
              <div class="relative">
                <input 
                  id="name" 
                  v-model="name" 
                  type="text" 
                  required
                  class="w-full px-4 py-3 bg-white/5 rounded-md text-white placeholder-zinc-500 focus:outline-none focus:ring-2 focus:ring-[#10B981] focus:border-[#10B981] transition-all duration-200"
                  placeholder="Seu nome completo"
                />
                <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-zinc-500">
                    <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                </div>
              </div>
            </div>

            <!-- CPF/CNPJ -->
            <div class="space-y-2">
              <label for="document" class="block text-sm font-medium text-zinc-200">CPF ou CNPJ</label>
              <div class="relative">
                <input 
                  id="document" 
                  v-model="document" 
                  type="text" 
                  required
                  v-maska="(document?.length ?? 0) <= 14 ? '###.###.###-###' : '##.###.###/####-##'"
                  class="w-full px-4 py-3 bg-white/5 rounded-md text-white placeholder-zinc-500 focus:outline-none focus:ring-2 focus:ring-[#10B981] focus:border-[#10B981] transition-all duration-200"
                  placeholder="000.000.000-00"
                />
                <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-zinc-500">
                    <rect width="18" height="18" x="3" y="3" rx="2"></rect>
                    <path d="M3 9h18"></path>
                    <path d="M9 21V9"></path>
                  </svg>
                </div>
              </div>
            </div>

            <!-- WhatsApp -->
            <div class="space-y-2">
              <label for="whatsapp" class="block text-sm font-medium text-zinc-200">WhatsApp</label>
              <div class="relative">
                <input 
                  id="whatsapp" 
                  v-model="whatsapp" 
                  type="text" 
                  required
                  v-maska="'(##) # ####-####'"
                  class="w-full px-4 py-3 bg-white/5 rounded-md text-white placeholder-zinc-500 focus:outline-none focus:ring-2 focus:ring-[#10B981] focus:border-[#10B981] transition-all duration-200"
                  placeholder="(00) 00000-0000"
                />
                <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-zinc-500">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                  </svg>
                </div>
              </div>
            </div>

            <!-- Email -->
            <div class="space-y-2">
              <label for="email" class="block text-sm font-medium text-zinc-200">Email</label>
              <div class="relative">
                <input 
                  id="email" 
                  v-model="email" 
                  type="email" 
                  required
                  class="w-full px-4 py-3 bg-white/5 rounded-md text-white placeholder-zinc-500 focus:outline-none focus:ring-2 focus:ring-[#10B981] focus:border-[#10B981] transition-all duration-200"
                  placeholder="seu@email.com"
                />
                <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-zinc-500">
                    <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
                  </svg>
                </div>
              </div>
            </div>

            <!-- Senha -->
            <div class="space-y-2">
              <label for="password" class="block text-sm font-medium text-zinc-200">Senha</label>
              <div class="relative">
                <input 
                  id="password" 
                  v-model="password" 
                  :type="showPassword ? 'text' : 'password'" 
                  required
                  class="w-full px-4 py-3 bg-white/5 rounded-md text-white placeholder-zinc-500 focus:outline-none focus:ring-2 focus:ring-[#10B981] focus:border-[#10B981] transition-all duration-200"
                  placeholder="••••••••"
                />
                <button 
                  type="button" 
                  @click="showPassword = !showPassword" 
                  class="absolute inset-y-0 right-0 flex items-center pr-3 text-zinc-500 hover:text-zinc-300 transition-colors"
                >
                  <svg v-if="!showPassword" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                  </svg>
                  <svg v-else xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M9.88 9.88a3 3 0 1 0 4.24 4.24"></path>
                    <path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68"></path>
                    <path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61"></path>
                    <line x1="2" x2="22" y1="2" y2="22"></line>
                  </svg>
                </button>
              </div>
              <p v-if="password.length > 0 && password.length < 8" class="text-red-500 text-xs mt-1">
                A senha deve ter pelo menos 8 caracteres
              </p>
            </div>

            <!-- Confirmar Senha -->
            <!-- <div class="space-y-2">
              <label for="confirmPassword" class="block text-sm font-medium text-zinc-200">Confirmar senha</label>
              <div class="relative">
                <input 
                  id="confirmPassword" 
                  v-model="confirmPassword" 
                  :type="showConfirmPassword ? 'text' : 'password'" 
                  required
                  class="w-full px-4 py-3 bg-white/5 rounded-md text-white placeholder-zinc-500 focus:outline-none focus:ring-2 focus:ring-[#10B981] focus:border-[#10B981] transition-all duration-200"
                  placeholder="••••••••"
                />
                <button 
                  type="button" 
                  @click="showConfirmPassword = !showConfirmPassword" 
                  class="absolute inset-y-0 right-0 flex items-center pr-3 text-zinc-500 hover:text-zinc-300 transition-colors"
                >
                  <svg v-if="!showConfirmPassword" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                  </svg>
                  <svg v-else xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M9.88 9.88a3 3 0 1 0 4.24 4.24"></path>
                    <path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68"></path>
                    <path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61"></path>
                    <line x1="2" x2="22" y1="2" y2="22"></line>
                  </svg>
                </button>
              </div>
              <p v-if="password && confirmPassword && password !== confirmPassword" class="text-red-500 text-xs mt-1">
                As senhas não coincidem
              </p>
            </div> -->

            <!-- Aviso HooPay -->
            <!-- <div class="p-4 bg-white/5 border border-zinc-800 rounded-md">
              <div class="flex items-center mb-3">
                <img src="https://dashboard.hoopay.com.br/shared/assets/02.png" alt="HooPay Logo" class="h-6 mr-2" />
                <span class="text-zinc-200 font-medium">Integração com HooPay</span>
              </div>
              <p class="text-zinc-400 text-sm leading-relaxed">
                Ao se cadastrar no Bot Express, você automaticamente criará uma conta na plataforma HooPay para processamento de pagamentos.
              </p>
            </div> -->

            <!-- Termos e condições -->
            <div class="flex items-start">
              <div class="flex items-center h-5">
                <input
                  id="terms"
                  v-model="acceptTerms"
                  type="checkbox"
                  required
                  class="peer sr-only"
                />
                <label for="terms" class="w-5 h-5 border border-zinc-600/50 rounded peer-checked:bg-[#10B981] peer-checked:border-[#10B981] transition-all duration-200 flex items-center justify-center">
                  <svg 
                    v-if="acceptTerms" 
                    xmlns="http://www.w3.org/2000/svg" 
                    width="14" 
                    height="14" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="currentColor" 
                    stroke-width="2" 
                    stroke-linecap="round" 
                    stroke-linejoin="round" 
                    class="text-white"
                  >
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </label>
              </div>
              <div class="ml-3 text-sm">
                <label for="terms" class="text-zinc-400 cursor-pointer leading-relaxed">
                  Eu concordo com os <a href="https://ajuda.hoopay.com.br/terms-of-services" target="_blank" class="text-[#10B981] hover:text-[#0EA271] font-medium">Termos de Serviço</a> e <a href="https://ajuda.hoopay.com.br/privacy" target="_blank" class="text-[#10B981] hover:text-[#0EA271] font-medium">Política de Privacidade</a>
                </label>
              </div>
            </div>

            <!-- Botão de cadastro -->
            <button 
              type="submit" 
              :disabled="isDisabled"
              :class="[
                'w-full py-3 px-4 font-medium rounded-md transition-colors duration-200 flex items-center justify-center',
                !isDisabled
                  ? 'bg-[#10B981] hover:bg-[#0EA271] text-white' 
                  : 'bg-zinc-800 text-zinc-500 cursor-not-allowed'
              ]"
            >
              <Loader2 v-if="isLoading" class="w-4 h-4 animate-spin mr-2" />
              <span>Criar conta</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ml-2">
                <path d="M5 12h14"></path>
                <path d="m12 5 7 7-7 7"></path>
              </svg>
            </button>
          </form>

          <!-- Logo HooPay grande -->
          <!-- <div class="mt-8 flex justify-center">
            <img src="https://dashboard.hoopay.com.br/shared/assets/15_2.png" alt="HooPay" class="h-10" />
          </div> -->

          <!-- Link para login -->
          <div class="mt-6 text-center">
            <p class="text-zinc-400 text-sm">
              Já tem uma conta?
              <RouterLink to="/login" class="text-[#10B981] hover:text-[#0EA271] font-medium ml-1 transition-colors">
                Fazer login
              </RouterLink>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { toast } from '@/components/ui/toast'
import { useAuth } from '@/composables/useAuth'
import router from '@/router'
import { Loader2 } from 'lucide-vue-next'
import { ref, computed } from 'vue'
import { vMaska } from "maska/vue"
import Cookies from 'js-cookie'

// Estado do formulário
const isLoading = ref(false)
const { register } = useAuth()
const name = ref('')
const email = ref('')
const document = ref('')
const whatsapp = ref('')
const password = ref('')
// const confirmPassword = ref('')
const showPassword = ref(false)
// const showConfirmPassword = ref(false)
const acceptTerms = ref(false)

const isDisabled = computed(() => 
  !name.value || 
  !email.value ||
  (!document.value && (document.value?.length ?? 0) > 14) ||
  !password.value ||
  password.value.length < 8 ||
  !whatsapp.value || 
  whatsapp.value.length < 16 ||
  !acceptTerms.value
)

// Função de cadastro
const handleRegister = async () => {
  if (isDisabled.value) {
    return
  }
  
  isLoading.value = true

  try {
    await register({
      name: name.value,
      organizationName: name.value,
      document: document.value,
      phoneNumber: whatsapp.value,
      email: email.value,
      password: password.value,
      organizations: true,
      source: Cookies.get('botexpress_source')
    })

    toast({
      title: 'Conta cadastrada com sucesso',
      class: 'bg-green-500 text-white',
      duration: 1500
    })

    router.push({ name: 'home' })
  } catch (error: any) {
    const uniqueCode = error?.response?.data?.errors?.[0]?.uniqueCode
    if (uniqueCode === 'CREATE_USER:USER_ALREADY_EXIST') {
      toast({
        title: 'E-mail já cadastrado',
        description: 'Este e-mail já está em uso. Faça login ou utilize outro e-mail.',
        class: 'bg-red-500 text-white',
        duration: 4000
      })
    } else {
      toast({
        title: 'Erro ao criar conta',
        description: 'Ocorreu um erro inesperado. Tente novamente.',
        class: 'bg-red-500 text-white',
        duration: 4000
      })
    }
  } finally {
    isLoading.value = false
  }
}
</script>

<style>
/* Melhorando a fonte */
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');

:root {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-feature-settings: "cv02", "cv03", "cv04", "cv11";
  letter-spacing: -0.015em;
}
</style>